<div class="min-h-screen bg-orange-50 relative flex flex-col items-center justify-center p-6 font-sans overflow-hidden">
  <!-- Glows Background -->
  <div class="absolute top-[-10%] left-[-10%] w-[500px] h-[500px] bg-brand-500/10 rounded-full blur-[120px] pointer-events-none animate-pulse-slow"></div>
  <div class="absolute bottom-[-10%] right-[-10%] w-[600px] h-[600px] bg-blue-500/10 rounded-full blur-[150px] pointer-events-none animate-pulse-slow" style="animation-delay: 2s;"></div>

  <!-- Logo -->
  <div class="absolute top-8 left-8 flex items-center gap-2">
    <span class="text-3xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-brand-600 to-brand-400 font-display tracking-tight">GYMO</span>
  </div>

  <!-- Card -->
  <div class="bg-white/70 backdrop-blur-2xl border border-white/60 shadow-[0_8px_30px_rgb(0,0,0,0.04)] rounded-[40px] p-10 lg:p-16 w-full max-w-2xl relative z-10 text-center animate-fade-in">
    <!-- Eyebrow -->
    <div class="flex items-center justify-center gap-2 text-slate-400 text-xs font-semibold tracking-[0.2em] uppercase mb-6">
      <span class="w-1.5 h-1.5 rounded-full bg-brand-500"></span>
      Erreur 404
    </div>

    <!-- 404 -->
    <h1 class="text-[6rem] lg:text-[9rem] leading-none font-extrabold text-transparent bg-clip-text bg-gradient-to-br from-brand-600 to-brand-400 font-display tracking-tight select-none">
      404
    </h1>

    <div class="w-16 h-1 bg-brand-500/20 rounded-full mx-auto my-8"></div>

    <h2 class="text-2xl lg:text-3xl font-extrabold text-slate-900 mb-4 font-display">
      Cette page n'est pas dans la salle
    </h2>
    <p class="text-slate-500 leading-relaxed max-w-md mx-auto mb-10">
      La page que vous cherchez n'existe pas, a été déplacée ou n'est plus accessible.
      Vérifiez l'adresse ou revenez à votre espace de travail.
    </p>

    <!-- Actions -->
    <div class="flex flex-col sm:flex-row items-center justify-center gap-3">
      <app-button-form
        label="Retour à l'accueil"
        iconName="Home"
        size="lg"
        (onClick)="goHome()"
      ></app-button-form>

      <app-button-form
        variant="outline"
        label="Page précédente"
        iconName="arrow-left"
        size="lg"
        (onClick)="goBack()"
      ></app-button-form>
    </div>
  </div>

  <p class="relative z-10 text-center text-xs text-slate-400 mt-8">
    Besoin d'aide ? Contactez l'administrateur de votre salle.
    <a href="https://wa.me/2250789962739?text=Bonjour%2C%20j'ai%20besoin%20d'aide." target="_blank" class="text-brand-500 hover:text-brand-600 transition-colors">+225 07 89 96 27 39</a>
  </p>
</div>
